import React, { useState } from "react";
import axios from "axios";
import moment from "moment";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CheckIcon from "@mui/icons-material/Check";
import Checkbox from "@mui/material/Checkbox";
import { IconButton } from "@mui/material";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import {
  Table,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
} from "@mui/material";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function AcceptUserModal({ user }) {
  const [open, setOpen] = useState(false);
  const [openToast, setOpenToast] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setIsChecked(false);
  };
  const handleCheck = (e) => {
    setIsChecked(!isChecked);
  };

  const handleAcceptReq = (user) => {
    axios
      .patch(`${process.env.REACT_APP_ADMIN_URL}/${user.email}`, {
        enabled: true,
      })
      .then((res) => {
        console.log(`${user.username} accepted succesfully`);
        window.location.reload();
      });
    setOpenToast(true);
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <div>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openToast}
          autoHideDuration={6000}
          onClose={handleCloseToast}
        >
          <Alert
            onClose={handleCloseToast}
            severity="success"
            sx={{ width: "100%" }}
          >
            User's request accepted!
          </Alert>
        </Snackbar>
        <Button
          variant="contained"
          onClick={handleOpen}
          sx={{
            backgroundColor: "#39b44a",
            "&:hover": { backgroundColor: "#39b44a" },
          }}
          startIcon={<CheckIcon />}
        >
          Accept
        </Button>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="modal">
            <div className="flex justify-between bg-[#ec644c]  align-baseline">
              <h3 className="text-gray-700 text-2xl mt-1 ml-2">Accept User</h3>
              <IconButton onClick={handleClose}>
                <CloseSharpIcon />
              </IconButton>
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <div className="requests-display">
                <div className="">
                  <div className="bg-gray-300">
                    <h3 className="text-gray-700 text-lg mt-1 ml-2">
                      Request Details
                    </h3>
                  </div>

                  <TableContainer component={Paper}>
                    <Table aria-label="user info table">
                      <TableBody>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Username
                          </TableCell>
                          <TableCell>{user.username}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Account ID
                          </TableCell>
                          <TableCell>{user.id}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Role
                          </TableCell>
                          <TableCell>{user.attributes.role}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Type
                          </TableCell>
                          <TableCell>{user.attributes.type}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Email
                          </TableCell>
                          <TableCell>{user.email}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell component="th" scope="row">
                            Requested
                          </TableCell>
                          <TableCell>
                            {moment(user.createdTimestamp).format(
                              "DD-MM-YYYY HH:mm:ss"
                            )}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <div className="flex justify-center my-4">
                    <Checkbox onChange={(e) => handleCheck(e)} />
                    <p className="mt-2 italic">
                      I have reviewed and responsibly accept the user.{" "}
                    </p>{" "}
                  </div>
                </div>
                <div className="flex justify-center">
                  {isChecked ? (
                    <Button
                      variant="contained"
                      onClick={() => handleAcceptReq(user)}
                      style={{
                        backgroundColor: "#39b44a",
                        "&:hover": { backgroundColor: "#39b44a" },
                      }}
                      startIcon={<CheckIcon />}
                    >
                      Accept
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      disabled={true}
                      startIcon={<CheckIcon />}
                    >
                      Accept
                    </Button>
                  )}
                </div>
              </div>
            </Typography>
          </Box>
        </Modal>
      </Stack>
    </div>
  );
}
